import { render, staticRenderFns } from "./online-shop.vue?vue&type=template&id=9bbb3142&"
import script from "./online-shop.vue?vue&type=script&lang=js&"
export * from "./online-shop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports